import {
  FeatureFlagsConfig,
  FeatureFlagsConfigValue,
} from '../../models/configuration/featureFlags.model';

export function getFlagValueFromConfig<T extends FeatureFlagsConfigValue = FeatureFlagsConfigValue>(config: FeatureFlagsConfig, flagName: string, defaultValue: boolean = false): T {
  return (config[flagName] ?? { enabled: defaultValue }) as T;
}